// extracted by mini-css-extract-plugin
export default {"common_container":"common_common_container__Cep2B","commom_subcontainer":"common_commom_subcontainer__NjAea","common_text":"common_common_text__fLhQC"};